import { LatLng, Marker } from "leaflet";
import { PaintMarker } from "../mapa";
import { Typography } from "@mui/material";

export interface UnidadeSensivelData {
  id: number;
  lat: number;
  lon: number;
  alt?: number;
  style: PaintMarker;
  nome: string;
  dataCadastro: Date;
  dataModificacao?: Date;
}

export class UnidadeSensivel extends Marker {
  // Propriedades da geometria
  public properties: UnidadeSensivelData;

  // Contrutor da Classe de Área
  constructor(latLng: LatLng, properties: UnidadeSensivelData) {
    super(latLng, properties.style);

    this.properties = properties;

    if (this.properties.style.bindPopUp) {
      this.bindPopup(this.popUpComponent(), {
        className: "",
        maxWidth: 390,
      });
    }
    if (this.properties.style.bindTooltip) {
      this.bindTooltip(this.tooltipComponent(), { direction: "top" });
    }
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "10em",
        width: "19em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          {this.properties.nome}
        </Typography>
      </div>
    );
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          {this.properties.nome}
        </Typography>
      </div>
    );
  }
}